import { CellPlugin } from '@react-page/editor';
import AccountDetails, {
    NAME_REQUIRED, NAME_LABEL, NAME_PLACEHOLDER,
    ADDRESS_LINE_1_LABEL, ADDRESS_LINE_1_PLACEHOLDER, ADDRESS_LINE_2_LABEL, ADDRESS_LINE_2_PLACEHOLDER, COUNTRY_LABEL,
    CITY_LABEL, CITY_PLACEHOLDER, STATE_LABEL, ADDRESS_REQUIRED, ZIP_CODE_LABEL, ZIP_CODE_PLACEHOLDER, ZIP_CODE_REQUIRED,
    PHONE_NUMBER_LABEL, PHONE_NUMBER_REQUIRED, EMAIL_ADDRESS_LABEL, EMAIL_ADDRESS_REQUIRED, MARGIN, PADDING, FULL_STORY_MASK
} from './components/AccountDetails';

type Data = {
    title: string,
    nameRequired: boolean,
    nameLabel: string,
    namePlaceholder: string,
    addressLine1Label: string,
    addressLine1Placeholder: string,
    addressLine2Label: string,
    addressLine2Placeholder: string,
    countryLabel: string,
    cityLabel: string,
    cityPlaceholder: string,
    stateLabel: string,
    addressRequired: boolean,
    zipCodeLabel: string,
    zipCodePlaceholder: string,
    zipCodeRequired: boolean,
    phoneNumberLabel: string,
    phoneNumberRequired: boolean,
    emailAddressLabel: string,
    emailAddressRequired: boolean,
    fullStoryMask: boolean,
    margin: string,
    padding: string
}

const AccountDetailsPlugin: CellPlugin<Data> = {
    Renderer: ({ data }) => (
        <AccountDetails
            nameRequired={data.nameRequired}
            nameLabel={data.nameLabel}
            namePlaceholder={data.namePlaceholder}
            addressLine1Label={data.addressLine1Label}
            addressLine1Placeholder={data.addressLine1Placeholder}
            addressLine2Label={data.addressLine2Label}
            addressLine2Placeholder={data.addressLine2Placeholder}
            countryLabel={data.countryLabel}
            cityLabel={data.cityLabel}
            cityPlaceholder={data.cityPlaceholder}
            stateLabel={data.stateLabel}
            addressRequired={data.addressRequired}
            zipCodeLabel={data.zipCodeLabel}
            zipCodePlaceholder={data.zipCodePlaceholder}
            zipCodeRequired={data.zipCodeRequired}
            phoneNumberLabel={data.phoneNumberLabel}
            phoneNumberRequired={data.phoneNumberRequired}
            emailAddressLabel={data.emailAddressLabel}
            emailAddressRequired={data.emailAddressRequired}
            fullStoryMask={data.fullStoryMask}
            margin={data.margin}
            padding={data.padding}
        />
    ),
    id: 'accountDetailsPlugin',
    title: 'Account Details',
    description: 'Collects the account details.',
    version: 1,
    controls: [
        {
            title: 'Labels',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        nameLabel: {
                            type: 'string',
                            default: NAME_LABEL,
                        },
                        namePlaceholder: {
                            type: 'string',
                            default: NAME_PLACEHOLDER,
                        },
                        addressLine1Label: {
                            type: 'string',
                            default: ADDRESS_LINE_1_LABEL,
                        },
                        addressLine1Placeholder: {
                            type: 'string',
                            default: ADDRESS_LINE_1_PLACEHOLDER,
                        },
                        addressLine2Label: {
                            type: 'string',
                            default: ADDRESS_LINE_2_LABEL,
                        },
                        addressLine2Placeholder: {
                            type: 'string',
                            default: ADDRESS_LINE_2_PLACEHOLDER,
                        },
                        countryLabel: {
                            type: 'string',
                            default: COUNTRY_LABEL,
                        },
                        cityLabel: {
                            type: 'string',
                            default: CITY_LABEL,
                        },
                        cityPlaceholder: {
                            type: 'string',
                            default: CITY_PLACEHOLDER,
                        },
                        stateLabel: {
                            type: 'string',
                            default: STATE_LABEL,
                        },
                        zipCodeLabel: {
                            type: 'string',
                            default: ZIP_CODE_LABEL,
                        },
                        zipCodePlaceholder: {
                            type: 'string',
                            default: ZIP_CODE_PLACEHOLDER,
                        },
                        phoneNumberLabel: {
                            type: 'string',
                            default: PHONE_NUMBER_LABEL,
                        },
                        emailAddressLabel: {
                            type: 'string',
                            default: EMAIL_ADDRESS_LABEL,
                        },
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Required Fields/Buttons',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        nameRequired: {
                            type: 'boolean',
                            default: NAME_REQUIRED,
                        },
                        addressRequired: {
                            type: 'boolean',
                            default: ADDRESS_REQUIRED,
                        },
                        zipCodeRequired: {
                            type: 'boolean',
                            default: ZIP_CODE_REQUIRED,
                        },
                        phoneNumberRequired: {
                            type: 'boolean',
                            default: PHONE_NUMBER_REQUIRED,
                        },
                        emailAddressRequired: {
                            type: 'boolean',
                            default: EMAIL_ADDRESS_REQUIRED,
                        },
                        fullStoryMask:{
                            type: 'boolean',
                            default: FULL_STORY_MASK
                        }
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Styles',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        margin: {
                            type: 'string',
                            default: MARGIN,
                        },
                        padding: {
                            type: 'string',
                            default: PADDING,
                        },
                    },
                    required: [],
                },
            },
        },
    ],
};

export default AccountDetailsPlugin;